var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-wrapper"},[_vm._v(_vm._s(_vm.$t("aiPredictionReport.averageOfYourAgeForTheNext10Years", {genderConvert: _vm.genderConvert})))])}
var staticRenderFns = []

export { render, staticRenderFns }